import Icon from './Icon';

const Dash = ({ className }) => (
  <Icon name="dash" className={className} viewBox="0 0 24 24">
    <path d="M3 11h18v2H3Z" />
  </Icon>
);

export default Dash;
